import React, { useState } from 'react';
const LensPowerCalculator = () => {
    const [refractiveIndex, setRefractiveIndex] = useState('');
    const [radius1, setRadius1] = useState('');
    const [radius2, setRadius2] = useState('');
    const [lensPower, setLensPower] = useState('');
    const [explanation, setExplanation] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!refractiveIndex || !radius1 || !radius2) {
            setError('Veuillez entrer tous les paramètres correctement');
            setLensPower('');
            setExplanation('');
            return;
        }
        const nValue = parseFloat(refractiveIndex);
        const r1Value = parseFloat(radius1);
        const r2Value = parseFloat(radius2);
        if (isNaN(nValue) || isNaN(r1Value) || isNaN(r2Value)) {
            setError('Veuillez entrer des paramètres valides');
            setLensPower('');
            setExplanation('');
            return;
        }
        const power = (nValue - 1) * (1 / r1Value - 1 / r2Value);
        setLensPower(power.toFixed(2));
        setExplanation(
            `Puissance de la lentille = (n - 1) × (1/R₁ - 1/R₂) = (${nValue} - 1) × (1/${r1Value} - 1/${r2Value}) = ${power.toFixed(2)} dioptries`
        );
        setError('');
    };
    return (
        <div dir="ltr">
            <div>
                <div className="form-group d-flex align-items-center">
                    <b>
                        <label className="form-label ms-2">Indice de réfraction (n)</label>
                    </b>
                    <input
                        type="number"
                        placeholder="1.5"
                        value={refractiveIndex}
                        onChange={(e) => setRefractiveIndex(e.target.value)}
                        className="form-control"
                        style={{ width: '150px' }}
                    />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                    <b>
                        <label className="form-label ms-2">Rayon 1 (m)</label>
                    </b>
                    <input
                        type="number"
                        placeholder="0.1"
                        value={radius1}
                        onChange={(e) => setRadius1(e.target.value)}
                        className="form-control"
                        style={{ width: '150px' }}
                    />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                    <b>
                        <label className="form-label ms-2">Rayon 2 (m)</label>
                    </b>
                    <input
                        type="number"
                        placeholder="-0.1"
                        value={radius2}
                        onChange={(e) => setRadius2(e.target.value)}
                        className="form-control"
                        style={{ width: '150px' }}
                    />
                </div>
                <br />
                <button
                    className="btn btn-success"
                    style={{ fontSize: '20px' }}
                    onClick={handleCalculate}
                >
                    Calculer
                </button>
            </div>
            <br />
            <div>
                {error !== '' ? (
                    <p className='p-3 mb-2 bg-warning text-white'>Erreur : {error}</p>
                ) : (
                    <>
                        {lensPower !== '' && (
                            <div className='p-3 mb-2 bg-success text-white'>
                                <p className='text-white'>Puissance de la lentille : {lensPower} dioptries</p>
                                <p className='text-white'><b>Explication :</b> {explanation}</p>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
export default LensPowerCalculator;
